import React, {PropsWithChildren} from "react";

export const RemoveFilterButton: React.FC<PropsWithChildren<{onCancel: () => void; className?: string}>> = ({
  children,
  className,
  onCancel,
}) => (
  <div className={["filter-remove__button", className].join(" ")}>
    {children}
    <span className="icon icon-close" onClick={onCancel} />
  </div>
);
